import { render, staticRenderFns } from "./ContentOrder.vue?vue&type=template&id=2ff134c0&"
import script from "./ContentOrder.vue?vue&type=script&lang=js&"
export * from "./ContentOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports